import { useEffect } from 'react';
import { FunctionalLoader } from 'seagull';
import { useStore, useStoreActions, useStoreStatic } from "../contexts";
import { selectors } from "../store/state-selectors";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * (1) Sets the feature-flags' relationship context to the supplied vendor - so useFeatureFlags() will retrieve the vendor's feature-flags.
 * (2) Renders the children only after the vendor's feature-flags are (asynchronously) available in the store.
 */
export default function FeatureFlagsRelationshipContext(props) {
  const {
    vendorId,
    children
  } = props;
  const ff = useStore(selectors.ff.featureFlags);
  const ffBusinessId = useStore(selectors.ff.ffBusinessId);
  const {
    getState
  } = useStoreStatic();
  const {
    ff: {
      setRelationshipVendorId
    }
  } = useStoreActions();
  useEffect(() => {
    const shouldChangeId = vendorId !== selectors.ff.ffBusinessId(getState());
    shouldChangeId && setRelationshipVendorId(vendorId);
    return () => {
      shouldChangeId && setRelationshipVendorId();
    };
  }, [vendorId]);
  return ffBusinessId === vendorId && ff.data ? /*#__PURE__*/_jsx(_Fragment, {
    children: children
  }) : /*#__PURE__*/_jsx(FunctionalLoader, {
    name: "fetchFF",
    show: true
  });
}